import { motion } from "framer-motion";
import { Home, UserRound, Check, ArrowRight } from "lucide-react";
import { PORTALS } from "../../lib/content";

const ICONS = { Home, UserRound };

export const Portals = () => {
  return (
    <section id="portals" data-testid="portals-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <span className="overline">Secure access</span>
          <h2 className="font-serif-display text-[#FDFBF7] text-3xl md:text-5xl tracking-tight mt-4 leading-tight">
            Portals for owners & residents
          </h2>
          <p className="text-[#A3B1A8] mt-5 text-base md:text-lg leading-relaxed">
            Everything you need, available anytime. Manage your home or your portfolio through a clean, secure
            online dashboard.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {PORTALS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.12, ease: "easeOut" }}
                data-testid={`portal-card-${i}`}
                className="group p-9 rounded-2xl bg-[#0F2119] border border-white/5 hover:border-[#D4AF37]/50 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center mb-6">
                  <Icon size={22} className="text-[#D4AF37]" />
                </div>
                <h3 className="font-serif-display text-[#FDFBF7] text-2xl mb-3">{p.title}</h3>
                <p className="text-[#A3B1A8] text-sm leading-relaxed mb-6">{p.desc}</p>
                <ul className="space-y-3 mb-8">
                  {p.points.map((pt) => (
                    <li key={pt} className="flex items-center gap-3 text-[#FDFBF7] text-sm">
                      <Check size={15} className="text-[#D4AF37] shrink-0" />
                      {pt}
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  data-testid={`portal-cta-${i}`}
                  className="group/btn inline-flex items-center gap-2 text-[#D4AF37] font-semibold text-sm hover:text-[#F0C742] transition-colors"
                >
                  {p.cta}
                  <ArrowRight size={16} className="group-hover/btn:translate-x-1 transition-transform duration-300" />
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
